import { render, staticRenderFns } from "./CrawlerOnly.vue?vue&type=template&id=f71cda80"
var script = {}
import style0 from "./CrawlerOnly.vue?vue&type=style&index=0&id=f71cda80&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports